import {
	BarsOutlined,
	StarOutlined,
	FileSearchOutlined,
} from "@ant-design/icons";
import { PERMISSION } from "../constants";
import { APP_PATH } from "constants/path";
import React from "react";
import { isProduction } from "utils/environment";
import { lazyRetry } from "utils/route";

// Rating & review
const RatingContent = React.lazy(() =>
	lazyRetry(() => import("../features/rating/content")),
);
const RatingContentDetail = React.lazy(() =>
	lazyRetry(() => import("../features/rating/content/detail")),
);
const CustomerRatings = React.lazy(() =>
	lazyRetry(() => import("../features/rating/customer")),
);
const MerchantRatings = React.lazy(() =>
	lazyRetry(() => import("../features/rating/merchant")),
);

const RatingRoutes = {
	label: "Rating and review",
	path: "",
	key: "ratings",
	icon: <StarOutlined />,
	permissions: [PERMISSION.RATING.LIST],
	children: [
		{
			label: "Rating content",
			path: APP_PATH.ratingContent,
			key: "contents",
			icon: <BarsOutlined />,
			component: <RatingContent />,
			permissions: [PERMISSION.RATING.LIST],
		},
		{
			label: "Rating content detail",
			path: APP_PATH.ratingContentDetail,
			key: "contents",
			icon: <BarsOutlined />,
			component: <RatingContentDetail />,
			hidden: true,
			permissions: [PERMISSION.RATING.LIST],
		},
		{
			label: "Customer rating",
			path: APP_PATH.customerRatings,
			key: "customerRatings",
			icon: <FileSearchOutlined />,
			component: <CustomerRatings />,
			permissions: [PERMISSION.RATING.LIST],
		},
		{
			label: "Merchant rating",
			path: APP_PATH.merchantRatings,
			key: "merchant",
			icon: <FileSearchOutlined />,
			component: <MerchantRatings />,
			permissions: [PERMISSION.RATING.LIST],
		},
	],
};

export default RatingRoutes;
